import { Card, Title, Text } from "@tremor/react";

/**
 * codex.md v4 — standard wrapper for every chart on the Financial page.
 *
 * Every chart site uses `<ChartCard title="..." subtitle="..." right={...}>`
 * so sizing, padding, and typography stay identical across the grid.
 *
 *   <ChartCard title="Revenue — 2026" subtitle="Actual · Expected · Forecast">
 *     <LineChart ... />
 *   </ChartCard>
 *
 * The `dark` class on the outer wrapper is what lets Tremor (which keys
 * dark mode off a class ancestor — configured in tailwind.config.js) use
 * its dark palette unconditionally, regardless of body-level theme.
 *
 * Layout:
 *  - Card padding comes from the Tremor .tremor-Card-root override in
 *    src/styles/tremor.css (18px top/bottom, 22px sides).
 *  - Header row is `display:flex` with the optional `right` node on the
 *    far right; gap is 16px so title + subtitle stay legible even when
 *    an action button sits next to them.
 *  - minHeight defaults to 280px so a chart + title always has breathing
 *    room; callers can override for tight layouts (NPS metric card).
 */
export default function ChartCard({ title, subtitle, right, minHeight = 280, children }) {
  return (
    <div className="dark" style={{ height: "100%" }}>
      <Card className="rc-chart-card" style={{ minHeight, display: "flex", flexDirection: "column", gap: 12 }}>
        <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 16 }}>
          <div style={{ minWidth: 0, flex: 1 }}>
            <Title>{title}</Title>
            {subtitle ? <Text style={{ marginTop: 3 }}>{subtitle}</Text> : null}
          </div>
          {right ? <div style={{ flexShrink: 0 }}>{right}</div> : null}
        </div>
        <div style={{ flex: 1, minHeight: 0 }}>{children}</div>
      </Card>
    </div>
  );
}
